<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <tg-search-tool @on-submit="handleSearch">
          <!-- <tg-dropdown v-if="$user.group >= 40" :items="dropdown_merchant" @on-change="handleMerchantChange" trigger="click"></tg-dropdown> -->
          <tg-date-search
            ref="dateSearch"
            size="small"
            v-model="dateRange"
            showDateRangePicker
            showTomorrow
            twoMonthLimit
          ></tg-date-search>
          <tg-dropdown :items="dropdown_report_type" @on-change="handleReportTypeChange" trigger="click"></tg-dropdown>
          <!-- <tg-dropdown :items="dropdown_bet_type" @on-change="handleBetTypeChange" trigger="click"></tg-dropdown> -->
          <!-- <el-input
            :placeholder="$t('component.form.input.placeholder.member')"
            v-model="searchData.targetName"
            class="tg-input"
            size="small"
            style="width: 120px"
            clearable
          ></el-input> -->
          <template slot="right"></template>
        </tg-search-tool>
      </el-row>
      <el-row style="padding:5px;">
        <!-- 平台選擇按鈕 -->
        <third-party-search-btn
          :style="{'display': !showMerchant ? 'none': 'initial'}"
          @click.native="showMerchantCheckBoxDialog"
          :text="$t('component.btn.merchant_choose')"
        ></third-party-search-btn>
        <merchant-platform
          :style="{'display': !showMerchant ? 'none': 'initial'}"
          v-model="merchantData"
          :merchantList="merchantList"
          @on-change="handleSearchMerchant"
        ></merchant-platform>
      </el-row>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      @on-loaded="handleLoaded"
      showSummary
      showPagination
    >
      <template slot="accTime" slot-scope="scope">
        <el-row
          type="flex"
          justify="space-around"
          align="middle"
        >
        {{scope.row['accTime']}}
        <span
          v-if="scope.row['dealMoney'] > 0"
          class="ma-l-2 clickable"
          @click="handleClick(scope.row)"
        >
          <i class="tg-icon tg-icon-openAccount"></i>
        </span>
          
        </el-row>
      </template>
    </tg-table>

    <!-- 平台篩選彈窗 -->
    <tg-merchant-check-box-dialog
      ref="merchantCheckBoxDialog"
      :merchantData="merchantData"
      :merchantList="merchantList"
      @on-click="handleSearchMerchant"
    ></tg-merchant-check-box-dialog>
    
    <tg-profit-dialog
      ref="dialog"
      :dialogInfo="dialogInfo"
    ></tg-profit-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgProfitDialog from "@/components/dialog/TgProfitDialog";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import MerchantPlatform from '@/components/tool/MerchantPlatform';
import TgMerchantCheckBoxDialog from "@/components/dialog/TgMerchantCheckBoxDialog";

// import { summary } from "@/utils/table";
// import str from "@/utils/str";


import apis from "@/apis";
import str from "@/utils/str";

const api = apis.accounts.profit;
const defaultProfitOptions = apis.accounts.public.getProfitDefaultOptions();

export default {
    components: {
        TgLayout,
        TgDateSearch,
        TgDropdown,
        TgSearchTool,
        TgProfitDialog,
        ThirdPartySearchBtn,
        MerchantPlatform,
        TgMerchantCheckBoxDialog
    },
    data() {
        return {
            columns: [],
            detailColumns:[],
            amountColumns:[],
            proxy: api.getData,
            dateRange: {},
            merchantData:[],
            merchantList:[],
            dropdown_bet_type:[],
            dropdown_report_type:[
              {
                label:this.$t("component.dropdown.report_type[0]"),
                value:0
              },
              {
                label:this.$t("component.dropdown.report_type[1]"),
                value:1
              },
            ],
            searchData: {
                userType:80,
                merchantName: ['NA001'],
                betType: 0,
                reportType: 0,
            },
            dialogInfo:[],
            showAmount: false,
        };
    },
    computed: {
        headerHeight() {
            return !this.showAmount ? 120 : 160;
        },
        request() {
            return { ...this.searchData, ...this.dateRange };
        },
        dateString() {
            return new Date().toISOString().replace(/[-:.]/g, "");
        },
        showMerchant(){
          return this.merchantList.length > 1;
        },
    },
    created() {
      // merchantOptions.then((result) => {
      //   this.dropdown_merchant.push({
      //     label: this.$t("component.dropdown.default"),
      //     value: ""
      //   });
      //   Object.values(result.data).forEach(item => {
      //       this.dropdown_merchant.push({
      //         label: item,
      //         value: item
      //       })
      //     });
      //   });
      defaultProfitOptions.then((result) => {
        this.dropdown_bet_type = JSON.parse(result.data);
        this.dropdown_bet_type.forEach(item => {
          item.label = this.$t(item.langKey);
        });
      });
      api.getColumns().then((response) => {
          this.columns = response.data.column;
          this.detailColumns = response.data.detailColumns;
          this.amountColumns = response.data.amountColumns;
          response.data.merchant.forEach(element => {
            this.merchantData.push(element.merchant_name);
            this.merchantList.push({
              text:element.merchant_name
            });
          });
          this.searchData.merchantName = this.merchantList.map(r => {
            return r.text;
          });

          this.$nextTick(() => {
            this.$refs.table.init(this.request);
          });
      });
    },
    methods: {
        // 查詢
        handleSearch() {
            this.$nextTick(() => {
              this.searchData.startDate = this.dateRange.startDate;
              this.searchData.endDate = this.dateRange.endDate;
                this.$refs.table.search(this.request);
            });
        },
        handleBetTypeChange(item) {
            this.searchData.betType = item.value;
        },
        handleMerchantChange(item) {
            this.searchData.merchantName = item.value;
        },
        handleReportTypeChange(item) {
            this.searchData.reportType = item.value;
        },

        //取得要搜尋的平台
        handleSearchMerchant(value) {
          this.merchantData = value;
          this.searchData.merchantName = this.merchantData;

          this.$nextTick(() => {
            let request = { ...this.request };
            this.$refs.table.search(request);
          });
        },
        // 處理response
        handleLoaded(response) {
          if (response.retcode == 0) {
            let columns = JSON.parse(JSON.stringify(this.columns));
            this.columns = columns;
            this.columns.forEach(item =>{
              if( item.langKey == "profit_benefit" || item.langKey == "profit_hand_over" ) {
                // 先轉換多國
                item.title = item.langKey
                  ? this.$t("column." + item.langKey)
                  : item.title;
                
                // 取代數值
                if( item.langKey == "profit_benefit" ) {
                    if(response.amount_data && response.amount_data.benefitPercent){
                      item.title = item.title +"("+ response.amount_data.benefitPercent * 100+"%)";
                    }
                } else {
                  if(response.amount_data && response.amount_data.SJPercent){
                      item.title = item.title +"("+ response.amount_data.SJPercent * 100+"%)";
                    }
                }
                
                // 刪除langKey，避免送進TgTable後重新翻譯多國取代上列結果
                delete item.langKey;
              }
            })
          }
        },
        handleClick(row) {
          this.dialogInfo = {
            detailColumns:this.detailColumns,
            amountColumns:this.amountColumns,
            searchStartDate:this.dateRange.startDate,
            searchEndDate:this.dateRange.endDate,
            startDate:row.accTime,
            endDate:row.accTime,
            merchantName:this.searchData.merchantName,
            reportType:this.searchData.reportType,
            title: str.format(
              "{0} - {1}",
              row.accTime,
              this.$t("component.label.detail")
            ),
          };
          this.$refs.dialog.showDialog();
        },

        showMerchantCheckBoxDialog(){
          this.$refs.merchantCheckBoxDialog.showDialog();
        }
    },
};
</script>
